/**
 * Serialize GoTrue auth mutations (signIn / signOut / refresh) so they never
 * run concurrently on the shared auth client. Concurrent auth ops were a
 * primary source of AbortError / "Connection was interrupted" on login.
 */
let authMutationChain: Promise<unknown> = Promise.resolve();

export function runAuthMutation<T>(fn: () => PromiseLike<T>): Promise<T> {
  const run = authMutationChain.then(() => fn(), () => fn());
  // Keep the chain alive even if this mutation rejects.
  authMutationChain = run.then(
    () => undefined,
    () => undefined,
  );
  return run;
}
